<template>
  <v-list color="#1A1D27" nav dense class="navbar-list white--text">

    <navbar-list-item
        v-for="(route, i) in routes"
        class="level-0 mt-3"
        :key="i"
        :route="route"
        :level="1"
        v-if="route.show"
    />
  </v-list>
</template>

<script>
import NavbarListItem from "./NavbarListItem";
import {VisitorLevels} from "@/variables";
import {PathLevels} from "@/variables";

export default {
  name: "NavBar",
  components: {NavbarListItem},
  data() {
    return {};
  },
  computed: {
    allRoutes() {
      return [
        {
          icon: "$dashboardIcon",
          title: "داشبورد",
          to: {
            name: "Home",
          },
        },
        ...(this.user && (this.user.user_type === "ma" || this.user.is_superuser) ? [{
          icon: "chat",
          title: "گفتگوهای دستیار فروش",
          to: {
            name: "AssistantConversations",
          },
        }] : []),
        {
          icon: "fa-users-cog",
          title: "مدیریت ادمین‌ها",
          to: {
            name: "AdminManagement",
          },
        },
        ...(this.user && (this.user.user_type === "ma" || this.user.is_superuser) ? [{
          icon: "fa-history",
          title: "تاریخچه تغییرات",
          to: {
            name: "AuditLogList",
          },
        }] : []),
        {
          icon: "$pardakhthaIcon",
          title: "فروش",
          children: [
            {
              icon: "$pardakhthaIcon",
              title: "داشبورد فروش",
              to: {
                name: "PartnerNewDashboard",
              },
            },
            {
              icon: "$reportIcon",
              title: "فروش سایت",
              to: {
                name: "SiteSales",
              },
            },
            {
              icon: "$reportIcon",
              title: "فروش حضوری (POS)",
              to: {
                name: "PosSales",
              },
            },
          ],
        },

        {
          icon: "$settingIcon",
          title: "تنظیمات",

          children: [
            ...(this.user && (this.user.user_type === "ma" || this.user.is_superuser) ? [{
              icon: "$settingIcon",
              title: "نسخه‌های اپ",
              to: { name: "AppReleases" },
            }, {
              icon: "$settingIcon",
              title: "هزینه ارسال",
              to: { name: "ShippingSettings" },
            }] : []),
            {
              icon: "$currencyIcon",
              title: "ارز",
              to: {
                name: "Currency",
              },
            },
            {
              icon: "$supplierIcon",
              title: "تامین کننده",
              to: {
                name: "Supplier",
              },
            },
            {
              icon: "$affiliateIcon",
              title: "شراکت",
              to: {
                name: "PartnerManagement",
              },
            },
          ],
        },
        {
          icon: "$warehouseIcon",
          title: "انبار",
          children: [
            {
              icon: "$warehouseIcon",
              title: "انبار ها",
              to: {
                name: "Store",
              },
            },
            {
              icon: "$inputFactorIcon",
              title: "انتقال انبار به انبار",
              to: {
                name: "StoreToStoreTransfer",
              },
            },
            {
              icon: "$reportIcon",
              title: "گزارش انتقال انبار به انبار",
              to: {
                name: "StoreToStoreTransferReport",
              },
            },

            {
              icon: "$getInformationIcon",
              title: "کمبود پردازش",
              to: {
                name: "PackingInventory",
              },
            },
            {
              icon: "$darentezarbastebandiIcon",
              title: "در حال انتقال",
              to: {
                name: "PendingTransfers",
              },
            },
            {
              icon: "$tarikhcheIcon",
              title: "داشبورد گزارش کمبود موجودی",
              to: {
                name: "SupplierLowInventoryByBrand",
              },
            },
            {
              icon: "$packagesIcon",
              title: "ستون و قفسه",
              to: {
                name: "PackingInfoProducts",
              },
            },
            {
              icon: "$allProductsIcon",
              title: "ادغام محصولات تکراری",
              to: {
                name: "AdminProductMerge",
              },
            },
            {
              icon: "$allProductsIcon",
              title: "محصولات ادغام شده",
              to: {
                name: "AdminMergedProducts",
              },
            },

          ],
        },
        {
          title: "محصول",
          icon: "$productIcon",
          children: [
            {
              icon: "$productBrandIcon",
              title: "برند محصول",
              to: {
                name: "Brand",
              },
            },
            {
              icon: "$productIcon",
              title: "محصول جدید",
              to: {
                name: "AdminProductForm",
              },
            },
            {
              icon: "$allProductsIcon",
              title: "مدیریت محصولات",
              to: {
                name: "AdminProductList",
              },
            },
            {
              icon: "$allProductsIcon",
              title: "مدیریت محتوا محصول",
              to: {
                name: "AdminProductListLite",
              },
            },
            ...(this.user && (this.user.user_type === "ma" || this.user.is_superuser) ? [{
              icon: "rate_review",
              title: "مدیریت نظرات",
              to: {
                name: "CommentModeration",
              },
            }] : []),
            {
              icon: "$reportIcon",
              title: "تغییر قیمت دسته جمعی",
              to: {
                name: "DomesticPriceChange",
              },
            },
            {
              icon: "$forooshkasbokarIcon",
              title: "کاتالوگ دسته جمعی",
              to: {
                name: "AdminProductBulkCat",
              },
            },
            {
              icon: "$forooshkasbokarIcon",
              title: "گزارش تغییرات موجودی",
              to: {
                name: "ProductStoreInventoryHistoryReport",
              },
            },
            {
              icon: "$kifpoolIcon",
              title: "لیبل",
              to: {
                name: "ProductLabelTable",
              },
            },
            //{
            //  icon: "$ledgerReportIcon",
            //  title: "تایین وضعیت یوان",
            //  to: {
            //    name: "ToFixYoan",
            //  },
            //},
            {
              icon: "$peygiriIcon",
              title: "اطلاعات پردازش ناقص",
              to: {
                name: "StoreNoInfoProducts",
              },
            },
            {
              icon: "$productBenefitIcon",
              title: "موجودی برند",
              to: {
                name: "ProductInventoryByBrandReport",
              },
            },
            {
              icon: "$outputFactorIcon",
              title: "خروج دستی",
              to: {
                name: "InventoryExportSelector",
              },
            },
            {
              icon: "$productBenefitIcon",
              title: "خواص محصول",
              to: {
                params: {
                  basePath: 'avails',
                  title: 'خواص'
                },
                name: "TreeManagement",
              },
            },
            {
              icon: "$productFeatureIcon",
              title: "ویژگی محصول",
              to: {
                params: {
                  basePath: 'feature',
                  title: 'ویژگی'
                },
                name: "TreeManagement",
              },
            },
            {
              icon: "$productCategoryIcon",
              title: "دسته بندی محصول",
              to: {
                params: {
                  basePath: 'categorization',
                  title: 'دسته بندی'
                },
                name: "TreeManagement",
              },
            },
            {
              icon: "$productCategoryIcon",
              title: "طیف رنگی محصول",
              to: {
                params: {
                  basePath: 'colorSpectrum',
                  title: 'طیف رنگی'
                },
                name: "TreeManagement",
              },
            },
          ],
        },
        {
          title: "پکینگ",
          icon: "$packagesIcon",
          children: [
            {
              title: "آپلود اولیه پکینگ ",
              icon: "$selectproductIcon",
              to: {
                name: "PackingUpload",
              },
            },
            {
              icon: "$darEntezarTahvilIcon",
              title: "پکینگ های در انتظار تایید",
              to: {
                name: "ExtractedEntrancePackageList",
              },
            },

            {
              icon: "$packagesIcon",
              title: "پکینگ ها",
              to: {
                name: "Packings",
              },
            },
            {
              icon: "$packagesIcon",
              title: "پکینگ های تکمیل شده",
              to: { name: "CompletedPackings" },
            },
            {
              title: "تایید تحویل",
              icon: "$sanadIcon",
              to: {
                name: "DeliverVerify",
              },
            },

          ],
        },
        {
          title: "تحویل",
          icon: "$storereceiptIcon",
          children: [
            {
              title: "تحویل پکینگ",
              icon: "$inputFactorIcon",
              to: {
                name: "WaitForDeliver",
              },
            },
            {
              title: "تحویل های خارجی",
              icon: "$productinputIcon",
              to: {
                name: "ChinaPackageDeliveries",
              },
            },
            {
              title: "تحویل های ایرانی",
              icon: "$productinputIcon",
              to: {
                name: "DomesticPackageDeliveries",
              },
            },
          ],
        },
        {
          title: "سفارشات",
          icon: "$ersalshodeIcon",
          children: [
            ...(this.user && (this.user.user_type === "ma" || this.user.is_superuser) ? [{
              icon: "$darentezarersalIcon",
              title: "ثبت سفارش دستی",
              to: {
                name: "ManualOrderCreate",
              },
            }] : []),
            {
              icon: "$bastebandiIcon",
              title: "سفارش های موفق جاری (ایران)",
              to: {
                name: "PaidShopOrderList",
              },
            },
            {
              icon: "$bastebandiIcon",
              title: "سفارش های موفق جاری (شیراز)",
              to: {
                name: "AdminShirazPaidOrders",
              },
            },
            {
              icon: "$darentezarersalIcon",
              title: "سفارش های در حال بسته بندی(ایران)",
              to: {
                name: "ProcessingOrders",
              }
            },
            {
              icon: "$darentezarersalIcon",
              title: "سفارش های در حال بسته بندی(شیراز)",
              to: {
                name: "ProcessingShirazOrders",
              }
            },
            {
              icon: "$shippedIcon",
              title: "سفارش های ارسال شده",
              to: {
                name: "ShippedOrdersList",
              }
            },
            {
              icon: "$darentezarersalIcon",
              title: "هزینه ارسال",
              to: { name: "ShippingCostReport" }
            },
            {
              icon: "$darentezarersalIcon",
              title: "ثبت کدپیگیری",
              to: {
                name: "RegisterTrackingCode",
              }
            },
            {
              icon: "$getInformationIcon",
              title: "ارسال نا معلوم به پست",
              to: {
                name: "ExtractedPostReportList",
              }
            }
          ],
        },
        {
          title: "انبارگردانی",
          icon: "$packagesIcon",
          children: [
            {
              icon: "$darentezarmohtava1Icon",
              title: "انبار گردانی نشده",
              to: {
                name: "AllStoreWaitForHandling",
              },
            },
            {
              icon: "$takmilmohtavaIcon",
              title: "انبار گردانی شده",
              to: {
                name: "AllStoreHandlingDone",
              }
            }
          ],
        },

        {
          title: "گزارشات",
          icon: "$reportIcon",
          children: [
            {
              icon: "$outputFactorIcon",
              title: "ارسال گزارش",
              to: {
                name: "IssuesForm",
              },
            },
            {
              icon: "$ledgerReportIcon",
              title: "گزارش های من",
              to: {
                name: "OwnIssuesList",
              }
            }
          ],
        },
        {
          title: "بخش مالی",
          icon: "$incomegenerationIcon",
          children: [
            {
              icon: "$incomegenerationIcon",
              title: "داشبور هزینه ها",
              to: {
                name: "ExpensesDashboard",
              },
            },
            {
              icon: "$ledgerReportIcon",
              title: "دفتر حساب",
              to: {
                name: "AccountingDashboard",
              },
            },
            {
              icon: "$outputFactorIcon",
              title: "گزارش‌های مالی",
              to: {
                name: "SalesReports",
              },
            },
            {
              icon: "$pardakhthaIcon",
              title: "سود خالص (ماهانه)",
              to: {
                name: "NetProfitMonthly",
              }
            },
            {
              icon: "$costAccountingIcon",
              title: "سود واحد نرم افزار",
              to: {
                name: "SoftwareDevelopmentProfit",
              },
            },
            {
              icon: "$reportIcon",
              title: "موجودی کل",
              to: {
                name: "InventoryReport",
              },
            },
            {
              icon: "$transactionIcon",
              title: "شارژ ولت",
              to: {
                name: "WalletTopUpFromOrder",
              },
            },

          ],
        },
        {
          title: "شریک",
          icon: "$reportIcon",
          children: [
            {
              icon: "$inputFactorIcon",
              title: "پرداخت به شریک",
              to: {
                name: "PartnerPaymentCreate",
              },
            },
            {
              icon: "$outputFactorIcon",
              title: "درخواست‌ برگشت محصول",
              to: {
                name: "PartnerStockExitCreate",
              },
            },
            {
              icon: "$sanadIcon",
              title: "تاریخچه برگشت محصول",
              to: {
                name: "PartnerStockExitManager",
              },
            },
          ],
        },
        {
          title: "گزارشات شریک",
          icon: "$reportIcon",
          children: [
            {
              icon: "$reportIcon",
              title: "مغایرت",
              to: {
                name: "AdminPartnerPackingDiscrepancy",
              },
            },
            {
              icon: "$allProductsIcon",
              title: "خلاصه محصولات",
              to: {
                name: "AdminPartnerCalculationsProducts",
              },
            },
            {
              icon: "$reportIcon",
              title: "گزارش روزانه",
              to: {
                name: "AdminPartnerCalculationsDailyPage",
              },
            },
            {
              icon: "$sanadIcon",
              title: "تسویه حساب",
              to: {
                name: "AdminPartnerCalculationsSettlementPage",
              },
            },
            {
              icon: "$outputFactorIcon",
              title: "مرجوعی‌ها",
              to: {
                name: "AdminPartnerCalculationsReturnsPage",
              },
            },
            {
              icon: "$reportIcon",
              title: "دقتِ سود آنلاین",
              to: {
                name: "AdminPartnerCalculationsCostExposurePage",
              },
            },
            {
              icon: "$gardeshhesabIcon",
              title: "جابه‌جایی مالکیت فروش",
              to: {
                name: "AdminSalesReassignment",
              },
            },
          ],
        },
      ]
    },
    storeKeeperRoutes() {
      return [
        { icon: '$packagesIcon', title: 'خروج کارتن‌های آنلاین', to: { name: 'OnlineKeeperWorkspace' } },
        {
          icon: "$dashboardIcon",
          title: "داشبورد",
          to: {
            name: "Home",
          },
        },
        {
          title: "انبارگردانی",
          icon: "$packagesIcon",
          children: [
            {
              icon: "$darentezarmohtava1Icon",
              title: "انبار گردانی نشده (واحد پردازش)",
              to: {
                name: "NoStoreHandleProducts",
              },
            },
            {
              icon: "$takmilmohtavaIcon",
              title: "انبار گردانی شده (واحد پردازش)",
              to: {
                name: "StoreHandleProducts",
              }
            }
          ],
        },

        {
          title: "گزارشات",
          icon: "$reportIcon",
          children: [
            {
              icon: "$outputFactorIcon",
              title: "ارسال گزارش",
              to: {
                name: "IssuesForm",
              },
            },
            {
              icon: "$ledgerReportIcon",
              title: "گزارش های من",
              to: {
                name: "OwnIssuesList",
              }
            }
          ],
        },
      ]
    },
    businessOwnerRoutes() {
      return [
        {
          icon: "$dashboardIcon",
          title: "داشبورد",
          to: {
            name: "Home",
          },
        },

        {
          icon: "$personalizationIcon",
          title: "شخصی سازی",
          to: {
            name: "AffiliateBusiness",
          },
        },
        {
          icon: "$kifpoolIcon",
          title: "کیف پول",
          to: {
            name: "Wallet",
          },
        },

        {
          icon: "$selectproductIcon",
          title: "انتخاب کالا",
          to: {
            name: "SelectAffiliateProductsForSale",
          },
        },
        {
          icon: "$sefareshhaykasbokarIcon",
          title: "سفارش های کسب و کار",
          to: {
            name: "BusinessOrdersReport",
          },
        },
        {
          icon: "$darentezarpardakhtIcon",
          title: "سفارش های در انتظار پرداخت",
          to: {
            name: "BusinessNotPaidOrders",
          },
        },
        {
          icon: "$gardeshhesabIcon",
          title: "گردش حساب کاربر",
          to: {
            name: "UserTurnover",
          },
        },
        {
          icon: "$pardakhthaIcon",
          title: "پرداخت ها",
          to: {
            name: "SubscriptionFactorsList",
          },
        },
        {
          icon: "$transactionIcon",
          title: "تراکنش ها",
          to: {
            name: "BusinessPaidOrders",
          },
        },
        {
          icon: "$crmIcon",
          title: "مشتری ها",
          to: {
            name: "AffiliateCustomers",
          },
        },
        {
          icon: "$sefareshatIcon",
          title: "گزارش  سفارشات",
          to: {
            name: "AffiliateAdminOrderPackages",
          },
        },


      ]
    },
    contentProductorRoutes() {
      return [
        {
          icon: "$allProductsIcon",
          title: "مدیریت محصولات",
          to: {
            name: "AdminProductList",
          },
        },
        // {
        //   icon: "$dashboardIcon",
        //   title: "داشبورد",
        //   to: {
        //     name: "Home",
        //   },
        // },
        // {
        //   icon: "$productBenefitIcon",
        //   title: "فایده محصول",
        //   to: {
        //     name: "Avail",
        //   },
        // },
        // {
        //   icon: "$productFeatureIcon",
        //   title: "خصوصیت محصول",
        //   to: {
        //     name: "ProductProperty",
        //   },
        // },
        // {
        //   icon: "$productCategoryIcon",
        //   title: "دسته بندی محصول",
        //   to: {
        //     name: "Category",
        //   },
        // },
        // {
        //   icon: "$darentezarmohtava1Icon",
        //   title: "محصولات در انتظار محتوا",
        //   to: {
        //     name: "NoContentProductList",
        //   },
        // },
        // {
        //   icon: "$takmilmohtavaIcon",
        //   title: "تکمیل محتوا محصول",
        //   to: {
        //     name: "ProductContentDevelopment",
        //   },
        // },
      ]
    },
    marketingRoutes() {
      return [
        {
          icon: "chat",
          title: "گفتگوهای دستیار فروش",
          to: {
            name: "AssistantConversations",
          },
        },
        {
          icon: "star",
          title: "محصولات ویژه",
          to: {
            name: "MarketingProductList",
          },
        },
        {
          icon: "photo_library",
          title: "بنر و اسلایدر",
          to: {
            name: "BannerManagement",
          },
        },
        {
          icon: "photo_library",
          title: "بنر لندینگ آرایشی",
          to: {
            name: "BeautyLandingBanners",
          },
        },
        {
          icon: "trending_up",
          title: "آمار و تحلیل محصولات",
          to: {
            name: "ProductMarketingStats",
          },
        },
        {
          icon: "local_offer",
          title: "کدهای تخفیف",
          to: {
            name: "DiscountCodes",
          },
        },
        {
          icon: "inventory_2",
          title: "پکیج ساز",
          to: {
            name: "PackageBuilder",
          },
        },
        {
          icon: "search",
          title: "سئو",
          children: [
            {
              icon: "category",
              title: "تنظیمات دسته‌بندی",
              to: {
                name: "CategorySeoSettings",
              },
            },
            {
              icon: "local_offer",
              title: "تنظیمات برند",
              to: {
                name: "BrandSeoSettings",
              },
            },
          ],
        },
      ]
    },
    partnerRoutes() {
      return [
        {
          icon: "$$dashboardIcon",
          title: "پیشخوان",
          to: {
            name: "PartnerNewDashboard",
          },
        },
        {
          icon: "$supplierIcon",
          title: "تامین کننده",
          to: {
            name: "Supplier",
          },
        },

        {
          icon: "$allProductsIcon",
          title: "مدیریت محصولات",
          to: {
            name: "PartnerProductList",
          },
        },
        {
          icon: "$reportIcon",
          title: "موجودی کل",
          to: {
            name: "InventoryReportByCurrency",
          },
        },
        {
          icon: "$bastebandiIcon",
          title: "گزارش فروش آنلاین",
          to: {
            name: "PartnerShopOrdersList",
          },
        },
        {
          icon: "$ersalshodeIcon",
          title: "گزارش فروش حضوری",
          to: {
            name: "PartnerInStoreOrdersList",
          },
        },
        {
          icon: "$outputFactorIcon",
          title: "درخواست‌ برگشت محصول",
          to: {
            name: "PartnerStockExitCreate",
          },
        },
        {
          icon: "$sanadIcon",
          title: "تاریخچه برگشت محصول",
          to: {
            name: "PartnerStockExitManager",
          },
        },

        {
          title: "پکینگ",
          icon: "$packagesIcon",
          children: [
            {
              title: "آپلود اولیه پکینگ ",
              icon: "$selectproductIcon",
              to: {
                name: "PartnerPackingUpload",
              },
            },
            {
              icon: "$darEntezarTahvilIcon",
              title: "پکینگ های در انتظار تایید",
              to: {
                name: "PartnerExtractedEntrancePackageList",
              },
            },

            {
              icon: "$packagesIcon",
              title: "پکینگ ها",
              to: {
                name: "Packings",
              },
            },
            {
              icon: "$packagesIcon",
              title: "پکینگ های تکمیل شده",
              to: { name: "CompletedPackings" },
            },
          ],
        },
        // موقتاً از منوی پنل شریک مخفی شده تا باگ‌هاش رفع بشه -- توی پنل مدیر کل
        // (allRoutes -> «گزارشات شریک») همچنان در دسترسه. روت‌ها حذف نشدن، فقط این
        // آیتم منو کامنت شده.
        // {
        //   icon: "$reportIcon",
        //   title: "محاسبات جدید",
        //   children: [
        //     {
        //       icon: "$allProductsIcon",
        //       title: "خلاصه محصولات",
        //       to: {
        //         name: "PartnerCalculations",
        //       },
        //     },
        //     {
        //       icon: "$reportIcon",
        //       title: "گزارش روزانه",
        //       to: {
        //         name: "PartnerCalculationsDaily",
        //       },
        //     },
        //     {
        //       icon: "$sanadIcon",
        //       title: "تسویه حساب",
        //       to: {
        //         name: "PartnerCalculationsSettlement",
        //       },
        //     },
        //     {
        //       icon: "$outputFactorIcon",
        //       title: "مرجوعی‌ها",
        //       to: {
        //         name: "PartnerCalculationsReturns",
        //       },
        //     },
        //   ],
        // },

      ]
    },
    packingAdminRoutes() {
      return [
        { icon: '$packagesIcon', title: 'بسته‌بندی سفارش‌های آنلاین', to: { name: 'OnlinePackerWorkspace' } },
        {
          icon: "$dashboardIcon",
          title: "داشبورد",
          to: {
            name: "Home",
          },
        },
        {
          icon: "$bastebandiIcon",
          title: "سفارش های موفق جاری (ایران)",
          to: {
            name: "PaidShopOrderList",
          },
        },
        {
          icon: "$bastebandiIcon",
          title: "سفارش های موفق جاری (شیراز)",
          to: {
            name: "AdminShirazPaidOrders",
          },
        },
        {
          icon: "$shippedIcon",
          title: "سفارش های ارسال شده",
          to: {
            name: "ShippedOrdersList",
          },
        },
        {
          title: "گزارشات",
          icon: "$reportIcon",
          children: [
            {
              icon: "$outputFactorIcon",
              title: "ارسال گزارش",
              to: {
                name: "IssuesForm",
              },
            },
            {
              icon: "$ledgerReportIcon",
              title: "گزارش های من",
              to: {
                name: "OwnIssuesList",
              }
            }
          ],
        },
      ]
    },
    supportRoutes() {
      return [
        {
          icon: "$ersalshodeIcon",
          title: "سفارشات",
          to: {
            name: "SupportOrdersList",
          },
        },
        {
          icon: "$kifpoolIcon",
          title: "کیف پول",
          to: {
            name: "WalletTopUpFromOrder",
          },
        },
      ]
    },
    mohsenRoutes() {
      return [
        {
          icon: "$dashboardIcon",
          title: "فروش حضوری",
          to: {
            name: "PosNewDashboard",
          },
        },
        {
          title: "سفارشات",
          icon: "$ersalshodeIcon",
          children: [
            {
              icon: "$bastebandiIcon",
              title: "سفارش های موفق جاری (ایران)",
              to: {
                name: "PaidShopOrderList",
              },
            },
            {
              icon: "$bastebandiIcon",
              title: "سفارش های موفق جاری (شیراز)",
              to: {
                name: "AdminShirazPaidOrders",
              },
            },
            {
              icon: "$darentezarersalIcon",
              title: "سفارش های در حال بسته بندی(ایران)",
              to: {
                name: "ProcessingOrders",
              }
            },
            {
              icon: "$darentezarersalIcon",
              title: "سفارش های در حال بسته بندی(شیراز)",
              to: {
                name: "ProcessingShirazOrders",
              }
            },
            {
              icon: "$shippedIcon",
              title: "سفارش های ارسال شده",
              to: {
                name: "ShippedOrdersList",
              }
            },
            {
              icon: "$darentezarersalIcon",
              title: "هزینه ارسال",
              to: { name: "ShippingCostReport" }
            },
            {
              icon: "$darentezarersalIcon",
              title: "ثبت کدپیگیری",
              to: {
                name: "RegisterTrackingCode",
              }
            },
            {
              icon: "$getInformationIcon",
              title: "ارسال نا معلوم به پست",
              to: {
                name: "ExtractedPostReportList",
              }
            }
          ],
        },

        {
          title: "محصول",
          icon: "$productIcon",
          children: [
            {
              icon: "$productIcon",
              title: "محصول جدید",
              to: {
                name: "AdminProductForm",
              },
            },
            {
              icon: "$allProductsIcon",
              title: "مدیریت محصولات",
              to: {
                name: "AdminProductList",
              },
            },
            {
              icon: "$forooshkasbokarIcon",
              title: "کاتالوگ دسته جمعی",
              to: {
                name: "AdminProductBulkCat",
              },
            },
            {
              icon: "$forooshkasbokarIcon",
              title: "گزارش تغییرات موجودی",
              to: {
                name: "ProductStoreInventoryHistoryReport",
              },
            },
            {
              icon: "$kifpoolIcon",
              title: "لیبل",
              to: {
                name: "ProductLabelTable",
              },
            },
            //{
            //  icon: "$ledgerReportIcon",
            //  title: "تایین وضعیت یوان",
            //  to: {
            //    name: "ToFixYoan",
            //  },
            //},
            {
              icon: "$peygiriIcon",
              title: "اطلاعات پردازش ناقص",
              to: {
                name: "StoreNoInfoProducts",
              },
            },
          ],
        },
        {
          icon: "$inputFactorIcon",
          title: "انتقال انبار به انبار",
          to: {
            name: "StoreToStoreTransfer",
          },
        },
        {
          icon: "$reportIcon",
          title: "گزارش انتقال انبار به انبار",
          to: {
            name: "StoreToStoreTransferReport",
          },
        },

        {
          icon: "$darentezarbastebandiIcon",
          title: "در حال انتقال",
          to: {
            name: "PendingTransfers",
          },
        },
        {
          icon: "$getInformationIcon",
          title: "کمبود پردازش",
          to: {
            name: "PackingInventory",
          },
        },

        {
          icon: "$peygiriIcon",
          title: "اطلاعات پردازش ناقص",
          to: {
            name: "StoreNoInfoProducts",
          },
        },
        {
          icon: "$packagesIcon",
          title: "ستون و قفسه",
          to: {
            name: "PackingInfoProducts",
          },
        },

        {
          title: "تحویل",
          icon: "$storereceiptIcon",
          children: [
            {
              title: "تحویل پکینگ (خارجی) ",
              icon: "$inputFactorIcon",
              to: {
                name: "WaitForDeliver",
              },
            },
            {
              title: "تحویل های خارجی",
              icon: "$productinputIcon",
              to: {
                name: "ChinaPackageDeliveries",
              },
            },
            {
              title: "تحویل های ایرانی",
              icon: "$productinputIcon",
              to: {
                name: "DomesticPackageDeliveries",
              },
            },

          ],
        },

      ]
    },
    routes() {
      let routes = this.allRoutes;
      if (this.user.username == 'shelfing-admin') {
        routes = this.mohsenRoutes;
      }
      if (this.user.user_type == 'prtnr') {
        routes = this.partnerRoutes;
      }
      if (this.user.user_type == 'stke') {
        routes = this.storeKeeperRoutes;
      } else if (this.user.user_type == 'so') {
        routes = this.contentProductorRoutes;
      } else if (this.user.user_type == 'buow') {
        routes = this.businessOwnerRoutes;
      } else if (this.user.user_type == 'paad') {
        routes = this.packingAdminRoutes;
      } else if (this.user.user_type == 'mkt') {
        routes = this.marketingRoutes;
      } else if (this.user.user_type == 'suprt') {
        routes = this.supportRoutes;
      }
      let setVisibility = (route) => {
        let visible = false;

        if (route.module && !this.hasModule(route.module)) {
          visible = false;
        } else if (route.extensionId && !this.hasExtension(route.extensionId)) {
          visible = false;
        } else if (route.feature && !this.hasFeature(route.feature)) {
          visible = false;
        } else if (route.perm) {
          visible = this.hasPerm("", route.perm);
        } else if (route.children) {
          for (let child of route.children) {
            visible |= setVisibility(child);
          }
          route.show = visible;
        } else {
          visible = true;
        }

        route.show = visible;
        return visible;
      };

      for (let route of routes) {
        setVisibility(route);
      }
      return routes;
    },
    username() {
      let user = this.$store.state.user;
      if (user.username.includes("manager")) return "manager";
      return user.username;
    },
  },
};
</script>

<style lang="scss">
.navbar-list {
  border: none !important;

  .list-item-title {
    font-weight: 300 !important;
    font-size: 0.9rem !important;
  }

  .level-0.v-list-group--active > .v-list-group__header {
  }

  .level-2 > .v-list-item--active {
  }

  .level-3.v-list-item--active {
    &:before {
    }

    border: none !important;
    border-radius: 4px !important;

    .v-list-item__title {
      color: #212121 !important;
    }
  }

  .v-list-group__header__append-icon,
  .v-list-group__header__prepend-icon {
    color: #11151C !important;
  }
}
</style>
